import { chakra, forwardRef, useMultiStyleConfig } from '@chakra-ui/react';
import type { HTMLChakraProps } from '@chakra-ui/react';
import type { ReactNode } from 'react';

import {
  DragSummaryStylesProvider,
  type DragSummaryStyles,
} from './DragSummaryStylesContext';
import { DraggedItemDescription } from './DraggedItemDescription';

export type DragSummaryProps = HTMLChakraProps<'div'> & {
  draggedItemDescription: ReactNode;
};

/**
 * Displays a summary of the items being dragged during drag-and-drop.
 *
 * This component is a pure display component, intended to be agnostic to what
 * drag-and-drop library it is used with.
 */
export const DragSummary = forwardRef<DragSummaryProps, 'div'>(
  ({ draggedItemDescription, ...restProps }, forwardedRef) => {
    const dragSummaryStyles = useMultiStyleConfig(
      'DragSummary',
      {},
    ) as DragSummaryStyles;

    const { container: dragSummaryContainerStyles } = dragSummaryStyles;

    return (
      <chakra.div
        ref={forwardedRef}
        __css={dragSummaryContainerStyles}
        {...restProps}
      >
        <DragSummaryStylesProvider value={dragSummaryStyles}>
          <DraggedItemDescription>
            {draggedItemDescription}
          </DraggedItemDescription>
        </DragSummaryStylesProvider>
      </chakra.div>
    );
  },
);
DragSummary.displayName = 'DragSummary';
